import script from "./ViewGeneratePVWithWarrantPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGeneratePVWithWarrantPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewGeneratePVWithWarrantPage.vue?vue&type=style&index=0&id=6b6ade1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6ade1a"]])

export default __exports__